import type { IconProps } from './types';

/** PDF document icon — red, used in contract lists */
export function PdfIcon({ className = 'h-6 w-6', ...props }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M21 0H3C1.35 0 0 1.35 0 3V21C0 22.65 1.35 24 3 24H21C22.65 24 24 22.65 24 21V3C24 1.35 22.65 0 21 0ZM8.25 11.25C8.25 12.495 7.245 13.5 6 13.5H4.5V16.5H2.25V7.5H6C7.245 7.5 8.25 8.505 8.25 9.75V11.25ZM15.75 14.25C15.75 15.495 14.745 16.5 13.5 16.5H9.75V7.5H13.5C14.745 7.5 15.75 8.505 15.75 9.75V14.25ZM21.75 9.75H19.5V11.25H21.75V13.5H19.5V16.5H17.25V7.5H21.75V9.75ZM4.5 11.25H6V9.75H4.5V11.25ZM12 14.25H13.5V9.75H12V14.25Z"
        fill="#EF5350"
      />
    </svg>
  );
}

/** Transfer — bi-directional arrows for wallet transfers */
export function TransferIcon({ className = 'h-4 w-4', ...props }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12.4027 0L15.9464 3.54364L12.4027 7.08728V4.42955H8.8591V2.65773H12.4027V0ZM6.20137 2.65773C5.71412 2.65773 5.31546 3.05639 5.31546 3.54364C5.31546 4.03089 5.71412 4.42955 6.20137 4.42955C6.68862 4.42955 7.08728 4.03089 7.08728 3.54364C7.08728 3.05639 6.68862 2.65773 6.20137 2.65773ZM2.65773 2.65773C2.17048 2.65773 1.77182 3.05639 1.77182 3.54364C1.77182 4.03089 2.17048 4.42955 2.65773 4.42955C3.14498 4.42955 3.54364 4.03089 3.54364 3.54364C3.54364 3.05639 3.14498 2.65773 2.65773 2.65773ZM3.54364 11.5168H7.08728V9.74501H3.54364V7.08728L0 10.6309L3.54364 14.1746V11.5168ZM9.74501 11.5168C10.2323 11.5168 10.6309 11.1182 10.6309 10.6309C10.6309 10.1437 10.2323 9.74501 9.74501 9.74501C9.25776 9.74501 8.8591 10.1437 8.8591 10.6309C8.8591 11.1182 9.25776 11.5168 9.74501 11.5168ZM13.2887 11.5168C13.7759 11.5168 14.1746 11.1182 14.1746 10.6309C14.1746 10.1437 13.7759 9.74501 13.2887 9.74501C12.8014 9.74501 12.4027 10.1437 12.4027 10.6309C12.4027 11.1182 12.8014 11.5168 13.2887 11.5168Z" />
    </svg>
  );
}

/** Clock — used in session timers, countdowns */
export function ClockIcon({ className = 'h-5 w-5', ...props }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}

/** Card front — ID document front */
export function CardFrontIcon({ className = 'h-8 w-8', ...props }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0" />
    </svg>
  );
}

/** Face / selfie — identity verification */
export function FaceIcon({ className = 'h-8 w-8', ...props }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}
